import React, { Fragment } from "react";
import Appfooter from '../components/Appfooter';
import Fondo from '../assets/images/fondo.png';
import RegisterForm from '../components/molecules/RegisterForm';
const data = [
    {
        img: 'https://vamosoque.web.app/static/media/01.1395522d.png',
        title: 'Diseño de piezas publicitarias para medios digitales e impresos',
        description: ' Tenemos un equipo de diseñadores certificados a tu alcance, quienes desarrollaran la imagen gráfica de tu empresa cuando lo requieras.',
        value: '$5.000 COP',
    },
    {
        img: 'https://vamosoque.web.app/static/media/01.1395522d.png',
        title: 'Facebook ads',
        description: 'creamos la estrategia perfecta para llegar a tu público objetivo y así generar ventas efectivas. Valor del servicio $ 10.000cop costo pauta a convenir con cliente. Una empresa te cobra 600.000 aproximadamente por este servicio, de los cuales el 50% es para la pauta publicitaria y el 50% restante lo cobran por crear la estrategia. Con nosotros por el mismo precio vas a tener pautas mas eficientes y de mayor efectividad',
        value: '$10.000 COP Aprox',
    }, 
    {
        img: 'https://vamosoque.web.app/static/media/01.1395522d.png',
        title: 'Youtube',
        description: 'Creamos la estrategia perfecta para llegar a tu público objetivo y así generar ventas efectivas. Valor del servicio $ 10.000cop costo pauta a convenir con cliente Una empresa te cobra 600.000 aproximadamente por este servicio, de los cuales el 50% es para la pauta publicitaria y el 50% restante lo cobran por crear la estrategia. Con nosotros por el mismo precio vas a tener pautas más eficientes y de mayor efectividad.',
        value: '$10.000 COP Aprox',
    }, 
    {
        img: 'https://vamosoque.web.app/static/media/01.1395522d.png',
        title: 'SEO',
        description: 'Optimización en motores de búsqueda en la web para mejorar el posicionamiento en la lista de resultados Valor del servicio $ 200.000cop. normalmente una empresa o profesional en seo, te puede cobrar 1.800.000cop a 2.500.000cop. con nosotros tendrás un excelente servicio y por un costo sumamente bajo.',
        value: '$200.000 COP Aprox',
    }, 
    {
        img: 'https://vamosoque.web.app/static/media/01.1395522d.png',
        title: 'SEM',
        description: 'Conjunto de herramientas del marketing digital para organizar campañas y anuncio pagos en los buscadores. ',
        value: '$200.000 COP Aprox',
    },  
    {
        img: 'https://vamosoque.web.app/static/media/01.1395522d.png',
        title: 'Community manager',
        description: 'Nos encargamos de crear, administrar y potenciar las redes sociales, creamos la relación estrecha con el futuro cliente, lo fidelizamos, aumentamos tu interacción, tu enganche, aumentamos tus likes, seguidores, y damos respuesta oportuna a las inquietudes de tus clientes en las redes sociales. Pequeñas empresas: 100.000 medianas empresas 300.000 grandes empresas 700.000.',
        value: 'Según tamaño de la empresa',
    },  
    {
        img: 'https://vamosoque.web.app/static/media/01.1395522d.png',
        title: 'Creación de páginas web',
        description: 'Creamos tu página web a medida, hosting, dominio, diseño y programación por 500.000 plan básico, si tu empresa requiere una mayor programación y diseño contáctanos para darte un precio increíble.',
        value: 'Según tamaño del proyecto',
    },  
    {
        img: 'https://vamosoque.web.app/static/media/01.1395522d.png',
        title: 'Cursos de marketing',
        description: 'Si quieres aprender los principales conceptos, técnicas, y estrategias para que puedas implementar un plan de acción.',
        value: '20.000COP',
    },  
    {
        img: 'https://vamosoque.web.app/static/media/01.1395522d.png',
        title: 'Email marketing',
        description: 'Tenemos a disposición una base de datos, donde conocemos comportamientos de compra de los usuarios, donde crearemos la estrategia de envió de correos masivos para llegas tu futuro cliente o cliente objetivo',
        value: '$10 COP x Correo.',
    },  
    {
        img: 'https://vamosoque.web.app/static/media/01.1395522d.png',
        title: 'Campañas publicitarias y planes de mercadeo.',
        description: 'Generamos un palma estratégico para llevar tu marca al siguiente nivel. Posicionamos tu empresa y generamos le plan de acción. Costo $ 500.000 pequeños empresas  $3.200.000 medianas empresas grandes empresas $ 5.000.000',
        value: 'Según el plan',
    } ,  
    {
        img: 'https://vamosoque.web.app/static/media/01.1395522d.png',
        title: 'Producción de eventos',
        description: 'te asesoramos en todo lo pertinente a tu evento (locación, mobiliario, artistas, logística, aforo, consumo, permisos, etc) para que tu evento sea todo un éxito.',
        value: 'Bajo cotización',
    } ,  
    {
        img: 'https://vamosoque.web.app/static/media/01.1395522d.png',
        title: 'Inbound marketing',
        description: 'Tenemos técnicas no invasivas, donde mostramos una experiencia perfecta al usuario de tu marca en toda la web y las redes virtuales, para convertirlo en prospecto y cliente así enamorarlo de tu compañía. Costo mensual 1.500.000 empresas pequeñas',
        value: '1.500.000 COP',
    } ,  
    {
        img: 'https://vamosoque.web.app/static/media/01.1395522d.png',
        title: 'Outbaund marketing',
        description: 'Utilizar métodos agresivos e impactantes llamar la atención del cliente potencial para mostrar el producto o servicio tomamos como referencia una búsqueda de usuario permitiendo tener el indicador de que puede ser su cliente. Inundando la web sus redes, y todos sus dispositivos con tu información de manera agresiva precio 1.500.000 pequeña empresa',
        value: '1.500.000 COP',
    } ,  
    {
        img: 'https://vamosoque.web.app/static/media/01.1395522d.png',
        title: 'Ligthroom',
        description: 'Retoque, edición, creación, y revelado fotográfico $ 5.000 por edición.',
        value: '5.000 COP',
    } ,  
    {
        img: 'https://vamosoque.web.app/static/media/01.1395522d.png',
        title: 'Photoshop',
        description: 'Realizamos el diseño que necesites y también a modificación o inclusión  pertinente a tu diseño o fotografía',
        value: '5.000 COP',
    } ,  
    {
        img: 'https://vamosoque.web.app/static/media/01.1395522d.png',
        title: 'Creación App',
        description: 'Creamos tu app precio a convenir',
        value: 'Según magnitud de proyecto',
    } ,  
    {
        img: 'https://vamosoque.web.app/static/media/01.1395522d.png',
        title: 'Creación de identidad: ',
        description: 'Somos especialistas en creación de marca.',
        value: '100.000 COP',
    } ,  
    {
        img: 'https://vamosoque.web.app/static/media/01.1395522d.png',
        title: 'Campaña de influencer',
        description: 'Influencers, instagramers, youtubers.',
        value: 'Precio a convenir',
    } ,  
    {
        img: 'https://vamosoque.web.app/static/media/01.1395522d.png',
        title: 'Crowfunding de compañas publicitarias',
        description: 'donde  una empresa que necesite financiación para una campaña para x producto recaude de los usuarios le capital, este producto se lanza al mercado y los mismos usuarios que aportaron prueben y compren el producto, teniendo así: 1 una experiencia de consumidor, 2 un aporte positivo o negativo para la empresa 3- una venta efectiva por usuario 4- una utilidad para la empresa y el usuario.',
        value: 'Precio según negociación',
    },
    {
        img: 'https://vamosoque.web.app/static/media/01.1395522d.png',
        title: 'Edición de video',
        description: 'Editamos y organizamos tus tomas para crear videos corporativos videolyrics cine, y cualquier formato que necesite.',
        value: 'Precio según negociación',
    },
    {
        img: 'https://vamosoque.web.app/static/media/01.1395522d.png',
        title: 'Creación de identidad: ',
        description: 'Somos especialistas en creación de marca.',
        value: '100.000 COP',
    } ,
    {
        img: 'https://vamosoque.web.app/static/media/01.1395522d.png',
        title: 'Patrocinio ',
        description: 'Un equipo deportivo para que tu marca este en el equipamiento precio a convenir dependiendo del deporte.',
        value: 'Según negociación',
    },
    {
        img: 'https://vamosoque.web.app/static/media/01.1395522d.png',
        title: 'Patrocinio de eventos ',
        description: 'Patrocinar eventos precio a convenir dependiendo el evento.',
        value: 'Según evento',
    }   
]
const Analytics =() => {
        return (
            <Fragment> 
                <div className="bg-white right-chat-active" style={{backgroundImage: `url(${Fondo})`}}>
                    <div className="middle-sidebar-bottom">
                        <div className="middle-sidebar-left pe-0">
                            <div className="col-lg-12 bg-white">
                                <img src='https://vamosoque.web.app/static/media/01.1395522d.png' alt="banner" className="w-100" />
                            </div>
                            <RegisterForm />
                            <div className="row">
                                {data.length !== 0 && data.map(({img, title, description, value}, index)=>(
                                <div className="col-lg-12" key={index}>
                                    <div className="card w-100 border-0 shadow-none p-5 rounded-xxl bg-lightblue2 mb-3">
                                        <div className="row">
                                            <div className="col-lg-6">
                                                <img src={img} alt="banner" className="w-100" />
                                            </div>
                                            <div className="col-lg-6 ps-lg-5">
                                                <h2 className="display1-size d-block mb-2 text-grey-900 fw-700">{title}</h2>
                                                <p className="font-xssss fw-500 text-grey-500 lh-26">{description}</p>
                                                <a href="/defaultanalytics" className="btn w200 border-0 bg-primary-gradiant p-3 text-white fw-600 rounded-3 d-inline-block font-xssss">{value}</a>
                                            </div>
                                        </div>
                                    </div>  
                                </div>))}
                            </div>
                            <RegisterForm />
                        </div>
                    </div>
                </div>
                <Appfooter /> 
            </Fragment>
        );
}

export default Analytics;